@if(loader){
<app-loader></app-loader>
}
<p-card [header]="isEditMode ? 'Update Bill Of Material' : 'Create Bill Of Material'">
   <form [formGroup]="billOfMaterialForm">
      <div>
         <div class="field col-12 flex justify-content-between align-items-center"> 
            <div class="flex">
            <div>
               @if(isEditMode){
               <p-button label="Update" severity="info" (click)="update(billOfMaterialForm.value)" icon="pi pi-arrow-circle-up"
                  size="small"></p-button>
               }@else {
               <p-button label="Save" class="p-button-outlined ml-2 " icon="pi pi-save" size="small"
                  (click)="saveBOM(billOfMaterialForm.value,isEditMode)"></p-button>
               }
            </div>
            <!-- <div>
               <p-button label="Reset" class="p-button-outlined ml-2" icon="pi pi-replay" severity="info"
                   size="small" (onClick)="reset()"></p-button>
               </div> -->
            <div>
               <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                  size="small" (click)="cancel()"></p-button>
            </div>
            </div> 

            <div>
                <label class="block label-required" style="font-weight: bold;">Required Field</label>
            </div>
         </div>
         <div class="grid padd">
         
            <div class="col-12 md:col-4">
               <div class="field text-left" style="display: flex; flex-direction: column;">
                  <label class="label-required display">Finished Product</label>
                  <div style="display: flex; align-items: center;">
                     <p-autoComplete #productCodeAutoComplete formControlName="productCode" placeholder="Search Finished Goods"
                        (onSelect)="setProduct($event)" [suggestions]="filterProductList"
                        (completeMethod)="autosearchProduct($event)" field="customerCode"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.productCode.errors }" [appendTo]="'body'"
                        [forceSelection]="true" [readonly]="isEditMode" [style]="isEditMode ? { 'pointer-events': 'none' } : {}"
                        styleClass="w-full" inputStyleClass="w-full">
                        <ng-template let-item pTemplate="item">
                           <span>{{item.productCode}} - {{item.productName}}</span>
                        </ng-template>
                     </p-autoComplete>
                     <div style="margin-left: 10px;">
                        <p-button [disabled]="isEditMode" icon="pi pi-search" (click)="getProduct()" [raised]="true"
                           [size]="'small'" severity="info"></p-button>
                     </div>
                  </div>
               </div>
         
               <div class="field text-left">
                  <label class="label-required display">{{unitLabel}}</label>
                  <p-autoComplete formControlName="warehouseCode" [dropdown]="true" [suggestions]="filtewarehouse"
                     [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouseCode.errors }"
                     (completeMethod)="filteWarehouse($event)" (onSelect)="warehouseSelected($event)" [forceSelection]="true"
                     field="warehouseCode" placeholder="Search {{unitLabel}}" styleClass="w-full">
                     <ng-template let-item pTemplate="item">
                        <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                     </ng-template>
                  </p-autoComplete>
               </div>
            </div>
         
            <div class="col-12 md:col-4">
               <div class="field text-left">
                  <label for="UOM" class="label-required display">Unit Of Measure</label>
                  <p-autoComplete formControlName="unitsOfMeasureCode" [dropdown]="true" [suggestions]="filteruom"
                     [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitsOfMeasureCode.errors }"
                     (completeMethod)="filterUOM($event)" (onSelect)="onUnitOfMeasureSelect($event)" [forceSelection]="true"
                     field="unitsOfMeasureCode" placeholder="Search" styleClass="w-full">
                     <ng-template let-item pTemplate="item">
                        <span>{{item.unitsofMeasure}}</span>
                     </ng-template>
                  </p-autoComplete>
               </div>

               <div class="field text-left">
                  <label class="label-required display">Quantity To Produce</label>
                  <input pInputText type="number" min="0" step="any" formControlName="quantity" class="w-full p-inputtext-sm"
                     placeholder="0" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.quantity.errors }" />
               </div>

            </div>
         
            <div class="col-12 md:col-4">
               <div class="field text-left" style="padding: 0.4rem;">
                  <label class="label-required display">BOM Type</label>
                  <div class="align-items-center" style="margin: 0px 10px 10px 0px;">
                     <p-radioButton name="boMType" value="Manufacture" formControlName="boMType"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.boMType.errors }"></p-radioButton>
                     <label for="ingredient1" class="ml-2">Manufacture</label>
                     &nbsp;&nbsp;
                     <p-radioButton name="boMType" value="Kit" formControlName="boMType"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.boMType.errors }"></p-radioButton>
                     <label for="ingredient2" class="ml-2">Kit</label>
                  </div>
               </div>

               <div class="field text-left">
                  <label class="display">Q-Avail</label>
                  <input pInputText type="number" formControlName="quantityAvailable" class="w-full p-inputtext-sm" />
               </div>
            </div>

            
         
         </div>
         <div>
            <p-tabView>
               <p-tabPanel header="Raw Materials">
                  <div class="p-3">
               
                     <div class="flex justify-content-end align-items-center gap-2 mb-3 w-full">
                        <input pInputText type="text" [formControl]="searchKey" placeholder="Search Product" class="p-inputtext-sm"
                           style="height: 30px; width: 200px;" />
                        <p-button icon="pi pi-search" (click)="searchProduct()" size="small" severity="info"></p-button>
                        <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                           severity="info"></p-button>
                     </div>
               
                     <p-table #dt1 [value]="lineItemData" styleClass="p-datatable-sm p-datatable-striped" [paginator]="true" [rows]="10"
   [(first)]="first" [rowsPerPageOptions]="[10,15,20]" [showCurrentPageReport]="true"
   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(selection)]="selectedProduct">

   <ng-template pTemplate="header">
      <tr>
         <th style="width: 4rem">Sr no.</th>
         <th style="width: 8rem">Product Code</th>
         <th style="width: 14rem">Product Name</th>
         <th style="width: 2rem"></th>
         <th style="width: 7rem">Size</th>
         <th style="width: 9rem">UOM</th>
         <th style="width: 6rem">Quantity</th>
         <th style="width: 8rem">MAKE</th>
         <th style="width: 13rem">Vendor</th>
         <th style="width: 8rem">Product Cost</th>
         <th style="width: 5rem">Delete</th>
      </tr>
   </ng-template>

   <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr>
         <td>{{ dt1.first + rowIndex + 1 }}</td>
         <td>{{ row.productCode?.split(' - ')[0] }}</td>
         <td>{{ row.productCode?.split(' - ').slice(1).join(' - ') }}</td>
         <td>
            <span class="text-lg cursor-pointer" (click)="showSpecification(row)" pTooltip="Specification">
               <i class="pi pi-flag-fill"></i>
            </span>
         </td>
         <td>
            <input type="text" pInputText class="p-inputtext-sm w-full" [(ngModel)]="row.productSize"
               [ngModelOptions]="{standalone: true}" />
         </td>
         <td>
            <p-dropdown [options]="UOMDropdown" optionLabel="unitsofMeasure" optionValue="unitsofMeasureId"
               [(ngModel)]="row.unitsOfMeasureId" [ngModelOptions]="{standalone: true}"
               (onChange)="onRowUomChange(row, $event)" appendTo="body" placeholder="Select"
               [style]="{'width':'100%'}"></p-dropdown>
         </td>
         <td>
            <input type="number" min="0" pInputText class="p-inputtext-sm w-full" [(ngModel)]="row.compQuantity"
               [ngModelOptions]="{standalone: true}" (keydown)="onKeyDownQty($event)" />
         </td>
         <td>
            <input type="text" pInputText class="p-inputtext-sm w-full" [(ngModel)]="row.make"
               [ngModelOptions]="{standalone: true}" />
         </td>
         <td>
            <div class="p-inputgroup">
               <input pInputText type="text" class="p-inputtext-sm" readonly placeholder="Select Vendor"
                  [value]="row.vendorCode ? (row.vendorCode + ' - ' + (row.vendorName || '')) : ''" />
               <button type="button" pButton icon="pi pi-search" class="p-button-sm" (click)="openVendorLookup(row)"></button>
            </div>
         </td>
         <td>
            <input type="number" min="0" pInputText class="p-inputtext-sm w-full" [(ngModel)]="row.standardCost"
               [ngModelOptions]="{standalone: true}" (keydown)="onKeyDownQty($event)" />
         </td>
         <td>
            <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-rounded p-button-sm"
               (click)="removeRawMaterial(row)"></button>
         </td>
      </tr>
   </ng-template>

   <ng-template pTemplate="emptymessage">
      <tr>
         <td colspan="11" class="text-center">No raw materials added. Search below to add one.</td>
      </tr>
   </ng-template>

   <ng-template pTemplate="footer">
      <tr>
         <td colspan="11">
            <p-autoComplete [formControl]="rawMaterialSearch" placeholder="Search Raw Material Product"
               [suggestions]="filterRawMaterialList" (completeMethod)="autosearchRawMaterial($event)"
               (onSelect)="addRawMaterial($event)" field="formattedCode" [forceSelection]="true" [dropdown]="true"
               dropdownIcon="pi pi-search" appendTo="body">
               <ng-template let-item pTemplate="item">
                  <span>{{item.productCode}} - {{item.productName}} - {{item.productSize}}</span>
               </ng-template>
            </p-autoComplete>
         </td>
      </tr>
   </ng-template>
</p-table>
                  </div>
               </p-tabPanel>
            </p-tabView>
         </div>
      </div>
   </form>
</p-card>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
